import clsx from 'clsx';
import { ChangeEvent, useState } from 'react';

import { IInputBaseProps } from '~components/generic/elements/Input/Input';

export type TextAreaProps = IInputBaseProps & {
  value: string;
  onChange: (value: string) => void;
};

export const Textarea = ({
  name,
  label,
  value,
  placeholder,
  required,
  disabled,
  onChange,
  className,
}: TextAreaProps) => {
  const [activeValue, setActiveValue] = useState<string>(value === null ? '' : value);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const target = event.target;
    const newValue = target.value;
    setActiveValue(newValue);
    onChange?.(newValue);
  };

  const classes = clsx(
    {
      'c-input': true,
    },
    className,
  );

  // make sure to render an empty string if there is no value so we dont
  // switch from controlled to uncontrolled input; use 'value' prop of textarea, not 'defaultValue'
  //const sanitizedValue = value === null || value === undefined ? '' : value.toString();

  return (
    <div className={`c-form-element c-form-element--type-textfield c-form-element--${name}`}>
      {label && (
        <label className="c-label" htmlFor={name}>
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        className={classes}
        placeholder={placeholder}
        value={activeValue}
        onChange={handleChange}
        required={required}
        disabled={disabled}
      />
    </div>
  );
};

export default Textarea;
